export function domReady(callback: () => void): void {
  const state = document.readyState
  if (state === 'complete' || state === 'interactive') {
    setTimeout(callback, 0)
  } else {
    document.addEventListener('DOMContentLoaded', callback)
  }
}

export function loadScript(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`))
    document.head.appendChild(script)
  })
}
